import { getAllType, getDaohangType } from '@/axios/api'

const allType = {
  state: {
    allType: []
  },
  mutations: {
    SET_ALLTYPE (state, allType) {
      state.allType = allType
    }
  },
  actions: {
    ALLTYPE ({ commit }, params) {
      getAllType(params).then(res => {
        this.state.allType = res.data.data
        getDaohangType(params).then(res2 => {
          let data = res2.data.data
          const data2 = data.map(item => { return {id: item.id, jiancheng: item.category, menu_id: item.id, menu_cn: item.category} })
          const index = this.state.allType.findIndex(i => i.pmenu.jiancheng === '导航')
          this.state.allType[index].smenu = data2
        })
      })
    },
    DAOHANGTYPE ({ commit }, params) {
      getDaohangType(params).then(res => {
        let data = res.data.data
        const data2 = data.map(item => { return {id: item.id, jiancheng: item.category, menu_id: item.id, menu_cn: item.category} })
        const index = this.state.allType.findIndex(i => i.pmenu.jiancheng === '导航')
        this.state.allType[index].smenu = data2
      })
    }
  }
}

export default allType



// WEBPACK FOOTER //
// ./src/store/modules/getAllType.js